/// <reference path="../_all.ts" />

module library {
  'use strict';

  LibraryDetailDirective.$inject = [
      'libraryService',
      '$filter',
      'anchorNavService',
    ];

  export function LibraryDetailDirective (
      libraryService: library.ILibraryService,
      $filter : library.IUniqueFilter,
      anchorNavService : navigation.IAnchorNavService,
    ): ng.IDirective {

    return {
      restrict: 'E',
      scope: {
        data: '=libraryData',
      },
      templateUrl: 'library/LibraryDetailDirective',
      link: function (scope: ILibraryDetailDirectiveScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

        scope.$watch("data.selectedRevision", (newValue : Revision, oldValue : Revision) => {
          if (newValue && newValue != oldValue) {
            scope.data.selectedFileType = newValue.FileType[0];
          }
        });
        
        
        scope.$watch("data.selectedLanguageVariant", (newValue : LanguageVariant, oldValue : LanguageVariant) => {
          if (newValue && newValue != oldValue) {
            var revSelected = newValue.Revisions.filter((v, i, arr) => {
              return !!v.ReleaseDate;
            });

            if (revSelected.length <= 0) {
              scope.data.selectedRevision = newValue.Revisions[newValue.Revisions.length - 1];
            } else {
              scope.data.selectedRevision = revSelected[revSelected.length - 1];
            }
          }
        });
      
        scope.$watch("data.selectedRevision", (newValue : Revision, oldValue : Revision) => {
          if (newValue && newValue != oldValue) {
            scope.data.selectedFileType = newValue.FileType[0];
          }
        });
      
        scope.$watch("data.selectedFileType", (newValue : FileType, oldValue : FileType) => {
          if (newValue && newValue != oldValue) {
            scope.data.Revision = newValue.DocumentRev;
            anchorNavService.search("revid", scope.data.Revision.DocumentFileSrcRevID);
          }
        });

       
        scope.getLastRevision = (rev) => {
          if (!rev || !scope.data.Document) return null;

          var currentRev = scope.data.Document.Revisions.filter((doc) => { 
              return doc.DocumentFileSrcID == rev.DocumentFileSrcID && !!doc.ReleaseDate;
          });

          if (currentRev.length <= 0) return rev;
          return currentRev[currentRev.length - 1];
        }

        scope.getLinkToRev = (rev) : string => {
          if (!rev) return null;
          var fileSrcRevId : number = angular.isNumber(rev) ? rev : rev.DocumentFileSrcRevID
          if (fileSrcRevId) return anchorNavService.getPath() + "?revid=" + fileSrcRevId;
          return null;
        }

        scope.openDocumentRev = (ev, rev) => {
          if (!rev) return null;
          if (ev) ev.preventDefault();
          var fileSrcRevId : number = angular.isNumber(rev) ? rev : rev.DocumentFileSrcRevID
          anchorNavService.search("revid", fileSrcRevId);
          libraryService.loadDocumentDetails(scope.data, fileSrcRevId).then((data) => {
            scope.data = data;
          });
          
        }
              
        scope.getRevisionFileTypeDescription = (rev) => {
          if (!rev) return null;      
          if (!rev.DocumentRevDestName) return rev.FileTypeName; //papiervorlage
          return rev.FileTypeExt + ' – ' + (<misc.IAdvancedNumberFilter>$filter)('advancedNumber')(rev.DocumentRevDestSize,1024) +'B';// + ' (' + rev.FileTypeName + ')';
        }

        scope.isExpired = (revision) => {
          if (!revision) return false;
          if (revision.DocumentFileSrcRevExpirationDate) return revision.DocumentFileSrcRevExpirationDate <= new Date();
          return false;
        }

      }
    }
  }
} 
